import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, memo } from 'react';
import { StyledContainer } from './styled';
import { ContainerLayout } from './types';
export { ContainerLayout };
export const Container = memo(forwardRef(function Container({ fluid, layout, children, className, dataTestId }, ref) {
    return (_jsx(StyledContainer, { ref: ref, "$fluid": fluid, "$layout": layout, className: className, "data-testid": dataTestId, children: children }));
}));
